import { useGetOrganization } from '../hooks';

export default class NotificationSettingsModel {
  id: string;
  reviewerResponds: boolean;
  proponentUserResponds: boolean;
  otherReviewerResponds: boolean;
  otherProponentUserResponds: boolean;
  otherReviewCreated: boolean;
  otherReviewUpdated: boolean;
  reviewerDeadlines: number[];
  proponentUserDeadlines: number[];
  otherReviewerDeadlines: number[];
  otherProponentUserDeadlines: number[];
  boards?: string[];
  proponents?: { value: string; label: string }[];
  activities?: { value: string; label: string }[];

  constructor(data: any) {
    this.id = data.id || undefined;
    this.reviewerResponds = data.reviewerResponds ?? undefined;
    this.proponentUserResponds = data.proponentUserResponds ?? undefined;
    this.otherReviewerResponds = data.otherReviewerResponds ?? undefined;
    this.otherProponentUserResponds = data.otherProponentUserResponds ?? undefined;
    this.otherReviewCreated = data.otherReviewCreated ?? undefined;
    this.otherReviewUpdated = data.otherReviewUpdated ?? undefined;
    this.reviewerDeadlines = data.reviewerDeadlines || [];
    this.proponentUserDeadlines = data.proponentUserDeadlines || [];
    this.otherReviewerDeadlines = data.otherReviewerDeadlines || [];
    this.otherProponentUserDeadlines = data.otherProponentUserDeadlines || [];
    this.boards = Array.isArray(data.boards) ? data.boards.map(board => board.id) : [];
    this.proponents = Array.isArray(data.proponents)
      ? data.proponents.map(proponent => ({ value: proponent.id, label: proponent.name }))
      : [];
    this.activities = Array.isArray(data.activities)
      ? data.activities.map(activity => ({ value: activity.id, label: activity.name }))
      : [];
  }
}
